// Checked
import React from 'react';

const aux = (props) => <div> {props.children} </div>;

export default aux;
